import { render } from "./DeviceListPlaceholder.vue?vue&type=template&id=f798594e"
import script from "./DeviceListPlaceholder.vue?vue&type=script&lang=js"
export * from "./DeviceListPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__